<template>
  <div id="productPricing">
  <el-dialog
    title="转移产品至售价表"
    :visible.sync="productPricingShow"
    width="640px"
    style="overflow-y: auto;"
    :close-on-click-modal='false'>
    <div>
      <div style="margin: 20px;
        background-color: rgba(255, 251, 230, 1);
        border-radius: 4px;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(255, 229, 143, 1);
        float: left;">
        <div style="padding: 12px;float: left;">
          <div class="trumpet_icon" style="margin-top: 3px;margin-right: 10px;float: left;"></div>
          <div>转移至新售价表后，本条产品信息仅会保留“品名”字段的内容，不会导致商品库的打标数据缺失。转移后请及时到新售价表中补全剩余信息</div>
        </div>
      </div>
      <span
        style="color: red;
        width: 44px;
        display: inline-block;
        text-align: right;">
        *
      </span>
      <span>
        售价分类
      </span>
      <el-select v-model="childClassfiyid" placeholder="请选择" size="small" style="width: 425px;padding-left: 12px;">
        <el-option
          v-for="item in tableData"
          :key="item.value"
          :label="item.productClassifyName"
          :value="item.id"
          :disabled="item.id == classifyId">
        </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" style="margin-left: 100px;" @click="sure()" size="small">确 定</el-button>
      <el-button @click="cancel()" type="TheCustom" size="small" style="margin-left: 16px;">取 消</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "productPricing",
    data() {
      return {
        productPricingShow: false,
        productId: '',
        tableData: [],
        classifyId: '',
        childClassfiyid: '',
        type: '',
        term: {}
      }
    },
    methods: {
      // 接收父组件数据
      transferChildShow(id,classifyId,n,term) {
        this.type = n
        this.classifyId = classifyId
        this.productId = id
        this.productPricingShow = true
        if (term) {
          this.term = term
        }
        this.oneStep()
      },
      // 获取数据源
      oneStep() {
        let params={
          pageNum: '1',
          pageSize: '10000'
        }
        fetch({
          url: "hcm/ProductClassify/seletProductClassify",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.data.list;
          }
        })
        .catch(err => {
          this.$message.error(res.message);
        })
      },
      // 取消
      cancel() {
        this.productPricingShow = false
      },
      sure() {
        // if (this.type == 1) {
        //   this.sureOne()
        // } else {
          this.sureTwo()
        // }
      },
      // 确认
      // sureOne() {
      //   if (!this.childClassfiyid) {
      //     this.$message({
      //       message: '请选择售价分类',
      //       type: 'warning'
      //     });
      //     return;
      //   }
      //   let params={
      //     productId: this.productId,
      //     classfiyid: this.childClassfiyid,
      //   }
      //   fetch({
      //     url: "hcm/hcmProduct/changeProductClassfiy",
      //     method: "post",
      //     params: params,
      //     noFormat: true,
      //     responseType: "text"
      //   }).then(result => {
      //     let res = JSON.parse(result);
      //     let {data}=res
      //     if(res.status == '10000'){
      //       this.$message({
      //         message: '成功',
      //         type: 'success'
      //       });
      //       this.productPricingShow = false;
      //       this.$emit('customShow')
      //     }
      //    })
      //    .catch(err => {
      //      this.$message.error(res.message);
      //    })
      // },
      // 确认
      sureTwo() {
        if (!this.childClassfiyid) {
          this.$message({
            message: '请选择售价分类',
            type: 'warning'
          });
          return;
        }
        let params={
          hcmProductIds: this.productId,
          classifyid: this.classifyId,
          term: this.term,
          changeClassifyid: this.childClassfiyid
        }
        fetch({
          url: "hcm/hcmProduct/changeByTerm",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '批量转移成功，请到检索标准设置页面重新设置产品限价标准。',
              type: 'success'
            });
            this.productPricingShow = false;
            this.$emit('customShow')
            // this.$router.push({path:"/searchCriteriaSetting",query:{type:1}})

          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
         })
         .catch(err => {
           this.$message.error(res.message);
         })
      },
    }
  }
</script>
<style scoped lang="scss">

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
</style>
<style lang="scss">
  #productPricing{
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .trumpet_icon {
      display: inline-block;
      width: 15px;
      height: 15px;
      background: url("../../assets/img/other/trumpet_icon.png") no-repeat;
      background-position: center;
      vertical-align: sub;
    }
  }
</style>
